export const getScheduledTreatmentName = (appointment) => {
  if (appointment?.treatment?.name) {
    return appointment.treatment.name;
  }

  if (appointment?.pendingProduct?.pkg?.name) {
    return appointment.pendingProduct.pkg.name;
  }

  return '';
};
